import { ServiceApi } from '../../serviceApi/serviceApi';
import { config } from '../../config';
import {
  collectData as collectRegistryData,
  registryHasItems,
  shouldDisplayRegistryPage
} from './registry';

export const executeNamedQuery = (dataSource, queryName) => {
  const gatewayconfig = config.joyBlissGatewayConfig;
  const activeauth = dataSource.getEvent().getBestActiveAuth();
  const gateway = new ServiceApi(config.joyBlissGatewayConfig, dataSource.getEvent().getBestActiveAuth());
  switch (queryName) {
    case 'registry': return collectRegistryData(dataSource, gateway);
    case 'registryNote': return collectRegistryData(dataSource, gateway);
    case 'registryPageShouldDisplay': return shouldDisplayRegistryPage(dataSource, gateway);
    case 'registryHasItems': return registryHasItems(dataSource, gateway);
  }
}
